import axios from "axios";

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/web_api_server"
    : "https://www.ppkm.org.my/web_api_server";

//retrieve email
const retrieveEmailbyIC = async (membershipNo, sanitizedNRIC) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/member/retrieve_email/`,
      {
        membershipNo,
        sanitizedNRIC,
      }
    );

    console.log(response);

    if (response) {
      return response.data;
    } else {
      throw new Error("No Email Found.");
    }
  } catch (error) {
    console.error("No email found", error);
    return null;
  }
};

// check member exist by email
const CheckMemberExist = async (email) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/member/check_member_exist/`,
      {
        email,
      }
    );

    // return response;

    console.log(response);
    // console.log(response.data.success);
    // console.log(response.data.email_verified);

    if (response.data.success) {
      return response.data.success; // Return the userId on successful login
    } else {
      throw new Error("Invalid credentials");
    }
  } catch (error) {
    console.error("Login failed:", error);
    return null;
  }
};

const SendOTP = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/member/send_otp_code/`, {
      email,
    });

    // return response;

    console.log(response.data.success);
    console.log(response);

    if (response.data.success) {
      return response.data.otp; // Return the userId on successful login
    } else {
      throw new Error("Unsuccessful");
    }
  } catch (error) {
    console.error("Invalid Email", error);
    return null;
  }
};

// check member exist by email
const ResendOTPCode = async (email) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/member/resend_otp_code/`,
      {
        email,
      }
    );

    // return response;

    console.log(response.data.success);
    console.log(response);

    if (response.data.success) {
      return response.data.otp; // Return the userId on successful login
    } else {
      throw new Error("Unsuccessful");
    }
  } catch (error) {
    console.error("Login failed:", error);
    return null;
  }
};

//fetch active member by email
const FetchActiveMembershipsByEmail = async (email) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/member/fetch_active_members/`,
      {
        email,
      }
    );

    // return response;
    console.log(response);

    if (response) {
      return response.data; // Return the userId on successful login
    } else {
      throw new Error("No Active Members");
    }
  } catch (error) {
    console.error("Fetch failed:", error);
    return null;
  }
};

// check member password by userID
const CheckMemberPasswordByUserID = async (user_id, email) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/member/check_password_by_userID/`,
      {
        user_id,
        email,
      }
    );

    // return response;

    console.log(response.data.success);
    console.log(response);

    if (response.data) {
      return response.data; // Return the userId on successful login
    } else {
      throw new Error("Invalid credentials");
    }
  } catch (error) {
    console.error("Login failed:", error);
    return null;
  }
};

// Add authenticateUser function here
const UpdatePasswordAndPin = async (userID, password, NewPin) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/member/update_password_and_pin/`,
      {
        userID,
        password,
        NewPin,
      }
    );

    // return response;
    console.log(response.data.success);
    console.log(response);

    if (response.data.success) {
      // Store MemberID in local storage
      localStorage.setItem("memberId", response.data.memberId);
      localStorage.setItem("email", response.data.email);
      localStorage.setItem("member_type", response.data.member_type);
      localStorage.setItem("userId", response.data.userId);
      localStorage.setItem("committee_type", response.data.committee_type);

      return response.data; // Return the userId on successful login
    } else {
      throw new Error("Invalid credentials");
    }
  } catch (error) {
    console.error("Login failed:", error);
    return null;
  }
};

// Add authenticateUser function here
const authenticateUser = async (user_id, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/member/login/`, {
      user_id,
      password,
    });

    // return response;

    console.log(response.data.success);
    // console.log(response);

    if (response.data.success) {
      // Store MemberID in local storage
      localStorage.setItem("memberId", response.data.memberId);
      localStorage.setItem("email", response.data.email);
      localStorage.setItem("member_type", response.data.member_type);
      localStorage.setItem("userId", response.data.userId);
      localStorage.setItem("committee_type", response.data.committee_type);
      return response.data.memberId; // Return the userId on successful login
    } else {
      throw new Error("Invalid credentials");
    }
  } catch (error) {
    console.error("Login failed:", error);
    return null;
  }
};

//get Member Info by MemberId
const getMembersbyMemberId = async (memberId) => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_member_by_member_id/`,
      {
        memberId,
      }
    );
    console.log({ data });
    console.log(memberId);
    return data;
  } catch (error) {
    console.error("Error fetching member info:", error);
    return error;
  }
};

//get Corporate Members List
const getCorporateMembersList = async () => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_corporate_members_list/`
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching member:", error);
    return error;
  }
};

//get Individual Members List
const getIndividualMembersList = async () => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_individual_members_list/`
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching member:", error);
    return error;
  }
};

//get Affiliate Corporate Members List
const getAffiliateCorporateMembersList = async () => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_affiliate_corporate_members_list/`
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching member:", error);
    return error;
  }
};

//get Affiliate Individual Members List
const getAffiliateIndividualMembersList = async () => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_affiliate_individual_members_list/`
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching member:", error);
    return error;
  }
};

//get Associate Members List
const getAssociateMembersList = async () => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_associate_members_list/`
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching member:", error);
    return error;
  }
};

//get Honorary Members List
const getHonoraryMembersList = async () => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_honorary_members_list/`
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching member:", error);
    return error;
  }
};

//get Member Info by MemberId and Email
const getMemberInfo = async (memberId, email) => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(`${API_BASE_URL}/get_member_info/`, {
      memberId,
      email,
    });
    console.log(data);
    console.log(memberId);
    console.log(email);
    return data;
  } catch (error) {
    console.error("Error fetching member info:", error);
    return error;
  }
};

//get Member Info by MemberId and Email
const getMembershipInfo = async (memberId) => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(`${API_BASE_URL}/get_membership_info/`, {
      memberId,
    });
    console.log(data);
    console.log(memberId);
    return data;
  } catch (error) {
    console.error("Error fetching member info:", error);
    return error;
  }
};

//get Member Info by MemberId and Email
const getUserInfo = async (userID) => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(`${API_BASE_URL}/get_user_info/`, {
      userID,
    });
    console.log(data);
    console.log(userID);
    return data;
  } catch (error) {
    console.error("Error fetching member info:", error);
    return error;
  }
};

//Update User Info by userID
const updateProfile = async (userData) => {
  // const cropUrl = userData.croppedImage;
  try {
    const payload = {
      ...userData.userData,
      croppedImage: userData.croppedImage,
    };
    const response = await axios.post(
      `${API_BASE_URL}/update_profile/`,
      payload
    );

    console.log(payload);

    // console.log(userData.userData);
    // console.log(userData.croppedImage);
    console.log(response);

    return response.data;
  } catch (error) {
    console.error("Profile update failed:", error);
    return { success: false, message: "Profile update failed" };
  }
};

//get Member Allotment
const getMemberAllotment = async (memberId) => {
  try {
    // const value = memberId.memberId;
    const data = await axios.post(`${API_BASE_URL}/get_member_allotment/`, {
      memberId,
    });
    console.log(memberId);
    console.log(data);

    return data.data;
  } catch (error) {
    console.error("Error fetching member allotment info:", error);
    return error;
  }
};

//get Member Allotment
const createMemberUser = async (payload) => {
  try {
    const data = await axios.post(
      `${API_BASE_URL}/create_member_user/`,
      payload.payload
    );
    console.log(payload.payload);
    console.log(data);

    return data.data;
  } catch (error) {
    console.error("Error fetching member allotment info:", error);
    return error;
  }
};

//Update Member Info by Member Id and Email
const updateMembershipInfo = async (membershipInfo) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/update_membership_info/`,
      membershipInfo.MembershipInfo
    );

    console.log(membershipInfo.MembershipInfo);

    console.log(response);

    return response.data;
  } catch (error) {
    console.error("Membership Info update failed:", error);
    return { success: false, message: "Membership Info update failed" };
  }
};

//get Member Renewal History by Member Id
const getMembershipRenewalHistory = async (memberId) => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_membership_renewal_history/`,
      {
        memberId,
      }
    );
    console.log(data);
    console.log(memberId);
    return data;
  } catch (error) {
    console.error("Error fetching member info:", error);
    return error;
  }
};

//get Member Renewal History by Member Id
const getPaymentInfo = async (paymentId) => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_membership_payment_info/`,
      {
        paymentId,
      }
    );
    console.log(data);
    console.log(paymentId);
    return data;
  } catch (error) {
    console.error("Error fetching member info:", error);
    return error;
  }
};

//get Member Renew Info by Member ID when renew membership
const getRenewMembershipInfo = async (memberId) => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_renew_membership_info/`,
      {
        memberId,
      }
    );
    console.log(data);
    console.log(memberId);
    return data;
  } catch (error) {
    console.error("Error fetching member info:", error);
    return error;
  }
};

//Update Password
const updatePassword = async (
  userId,
  memberId,
  email,
  oldPassword,
  newPassword
) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/update_password/`, {
      userId,
      memberId,
      email,
      old_password: oldPassword,
      new_password: newPassword,
    });

    console.log(memberId);
    console.log(email);
    console.log(response);

    return response.data;
  } catch (error) {
    console.error("Password update failed:", error);
    return { success: false, message: "Password update failed" };
  }
};

//Reset Pin
const ResetPin = async (userId, oldPassword, NewPin) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/reset_pin/`, {
      userId,
      oldPassword,
      NewPin,
    });

    console.log(response);

    return response.data;
  } catch (error) {
    console.error("Password update failed:", error);
    return { success: false, message: "Password update failed" };
  }
};

const getUpcomingEventRows = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/get_member_event/`);
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching rows:", error);
    return error;
  }
};

const getPastEventRows = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/get_member_past_event/`);
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching rows:", error);
    return error;
  }
};

const getUserUpcomingEventRegistrations = async (memberId) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_user_upcoming_event_registrations/`,
      {
        memberId,
      }
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching rows:", error);
    return error;
  }
};

const getUserPastEventRegistrations = async (memberId) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_user_past_event_registrations/`,
      {
        memberId,
      }
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching rows:", error);
    return error;
  }
};

const getMemberEventRegistrations = async (memberId) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_member_event_registrations/`,
      {
        memberId,
      }
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching rows:", error);
    return error;
  }
};

const getEventRegistrationInfo = async (registrationID) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_event_registrations_info/`,
      {
        registrationID,
      }
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching rows:", error);
    return error;
  }
};

const getEventDetails = async (eventId) => {
  try {
    const value = eventId.eventId;
    const { data } = await axios.get(
      `${API_BASE_URL}/get_event_details/${value}`
    );
    console.log(data);
    console.log(eventId);
    return data;
  } catch (error) {
    console.error("Error fetching event details:", error);
    return error;
  }
};

//getEvent Price by eventID and member_type
const getEventPrice = async (eventId, member_type) => {
  try {
    // const value = memberId.memberId;
    const { data } = await axios.post(
      `${API_BASE_URL}/get_event_price/`,
      eventId,
      member_type
    );
    console.log(eventId);
    // console.log(member_type);
    return data;
  } catch (error) {
    console.error("Error fetching member info:", error);
    return error;
  }
};

//Register Event
const RegisterEvent = async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/register_event/`, data);

    console.log(data);

    console.log(response);

    return response.data;
  } catch (error) {
    console.error("Register failed:", error);
    return { success: false, message: "Register failed" };
  }
};

//get Registration Info by eventRegistrationID
const getRegistrationInfo = async (eventRegistrationID) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/get_registration_info/`,
      eventRegistrationID
    );

    console.log(eventRegistrationID);

    console.log(response);

    return response.data;
  } catch (error) {
    console.error("Fetch Data failed:", error);
    return { success: false, message: "Fetch Data failed" };
  }
};

const getEventCategories = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/get_event_categories/`);
    return data;
  } catch (error) {
    console.error("Error fetching event categories:", error);
    return error;
  }
};

const getEventCategoriesforPhotoGallery = async () => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/get_photo_gallery_event_categories/`
    );
    return data;
  } catch (error) {
    console.error("Error fetching event categories:", error);
    return error;
  }
};

const getEventbyEventCategories = async (eventCategoryId) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_event_by_event_categories/`,
      {
        eventCategoryId,
      }
    );
    return data;
  } catch (error) {
    console.error("Error fetching event:", error);
    return error;
  }
};

const getEventItembyEventId = async (eventId) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_event_item_by_event_id/`,
      {
        eventId,
      }
    );
    return data;
  } catch (error) {
    console.error("Error fetching event item:", error);
    return error;
  }
};

const getDocumentCategories = async () => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/get_document_categories/`
    );
    return data;
  } catch (error) {
    console.error("Error fetching document categories:", error);
    return error;
  }
};

const getViewableDocuments = async (
  documentCategoryID,
  memberTypeID,
  committeeTypeID
) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/get_viewable_documents/`,
      {
        documentCategoryID,
        memberTypeID,
        committeeTypeID,
      }
    );
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error fetching event item:", error);
    return error;
  }
};

const saveRow = async (payload) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/submit_edit_events/`,
      payload
    );
    return data;
  } catch (error) {
    console.error("Error saving row:", error);
    return error;
  }
};

const saveRowEventCategory = async (payload) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/submit_edit_event_category/`,
      payload
    );
    return data;
  } catch (error) {
    console.error("Error saving event category:", error);
    return error;
  }
};

const deleteEventRow = async (rowId) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/submit_delete_event/`,
      rowId
    );
    return data;
  } catch (error) {
    console.error("Error deleting event row:", error);
    return error;
  }
};

const publishEventRow = async (rowId) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/submit_publish_event/`,
      rowId
    );
    return data;
  } catch (error) {
    console.error("Error publishing event row:", error);
    return error;
  }
};

const deleteEventCategoryRow = async (rowId) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/submit_delete_event_category/`,
      rowId
    );
    return data;
  } catch (error) {
    console.error("Error deleting event category row:", error);
    return error;
  }
};

const createEvent = async (data) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  try {
    const response = await axios.post(
      `${API_BASE_URL}/submit_event/`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    console.error("API request failed:", error);
  }
};

const api = {
  retrieveEmailbyIC,
  CheckMemberExist,
  SendOTP,
  ResendOTPCode,
  FetchActiveMembershipsByEmail,
  CheckMemberPasswordByUserID,
  UpdatePasswordAndPin,
  authenticateUser,
  getMembersbyMemberId,
  getMemberInfo,
  getMembershipInfo,
  getCorporateMembersList,
  getIndividualMembersList,
  getAffiliateCorporateMembersList,
  getAffiliateIndividualMembersList,
  getAssociateMembersList,
  getHonoraryMembersList,
  getUserInfo,
  updateProfile,
  getMemberAllotment,
  createMemberUser,
  updateMembershipInfo,
  getMembershipRenewalHistory,
  getPaymentInfo,
  getRenewMembershipInfo,
  updatePassword,
  ResetPin,
  getUpcomingEventRows,
  getPastEventRows,
  getUserUpcomingEventRegistrations,
  getUserPastEventRegistrations,
  getMemberEventRegistrations,
  getEventRegistrationInfo,
  getEventDetails,
  getEventPrice,
  RegisterEvent,
  getRegistrationInfo,
  saveRow,
  getEventCategories,
  saveRowEventCategory,
  getEventCategoriesforPhotoGallery,
  getEventbyEventCategories,
  getEventItembyEventId,
  getDocumentCategories,
  getViewableDocuments,
  deleteEventRow,
  publishEventRow,
  deleteEventCategoryRow,
  createEvent,
};

export default api;
